function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M24 11h-2V9h-2v2h-2v2h2v2h2v-2h2v-2zM9 11v2.4h4c-.2 1-1.2 3-4 3-2.4 0-4.3-2-4.3-4.4 0-2.4 1.9-4.4 4.3-4.4 1.4 0 2.3.6 2.8 1.1l1.9-1.8C12.5 5.7 10.9 5 9 5c-3.9 0-7 3.1-7 7s3.1 7 7 7c4 0 6.7-2.8 6.7-6.8 0-.5 0-.8-.1-1.2H9z"
});

var SvgIcGooglePlus = function SvgIcGooglePlus(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTI0IDExaC0yVjloLTJ2MmgtMnYyaDJ2Mmgydi0yaDJ2LTJ6TTkgMTF2Mi40aDRjLS4yIDEtMS4yIDMtNCAzLTIuNCAwLTQuMy0yLTQuMy00LjQgMC0yLjQgMS45LTQuNCA0LjMtNC40IDEuNCAwIDIuMy42IDIuOCAxLjFsMS45LTEuOEMxMi41IDUuNyAxMC45IDUgOSA1Yy0zLjkgMC03IDMuMS03IDdzMy4xIDcgNyA3YzQgMCA2LjctMi44IDYuNy02LjggMC0uNSAwLS44LS4xLTEuMkg5eiIvPgo8L3N2Zz4K";
export { SvgIcGooglePlus as ReactComponent };